/**
 * The length of each item part in the uid generation flow
 * @type {Number}
 */
const UID_PART_LENGTH = 8;

export { UID_PART_LENGTH };
